const boUserGroupServiceTypes = {
  service: /* @__PURE__ */ Symbol("BoUserGroupService")
};
export {
  boUserGroupServiceTypes
};
//# sourceMappingURL=constants.js.map
